export default "/assets/images/mila-air-specs-sm.cf33905f2d148ec2.png";